import { useContext, useEffect } from 'react';
import { NavigationContext } from '../../context/NavigationContext';
import PropTypes from 'prop-types';
import { Heading, Loader } from 'shared/components';
import { ThemeProvider } from '@emotion/react';
import { TextField } from 'shared/fields';
import { ButtonContainer, LeadFormContainer, LeadFormInput, SuccessMessage } from 'shared/conversie';
import { PrimaryButton, PrimaryOutlineButton } from 'shared/buttons';

const LeadFormFinal = ({ handleSubmit, formIsLoading, onRequestClose, settings: { leadFormHeader, leadFormText } }) => {
  const { setLeadFormActive, leadFormShowSucces, setLeadFormShowSucces } = useContext(NavigationContext);
  useEffect(() => setLeadFormActive(true));

  return (
    <ThemeProvider theme={{ cardColor: '#ffffff' }}>
      {leadFormShowSucces ? (
          <SuccessMessage onRequestClose={() => {
              setLeadFormShowSucces(false);
              onRequestClose()
          }} />
      ) : (
          <LeadFormContainer>
            <Heading>{leadFormHeader}</Heading>
            <p>{leadFormText}</p>
            <LeadFormInput>
              <TextField placeholder='Voornaam' name='first_name' />
              <TextField placeholder='Tussenvoegsel' name='last_name_prefix' />
              <TextField placeholder='Achternaam' name='last_name' />
              <TextField placeholder='E-mailadres' name='email' />
              <TextField placeholder='Telefoonnummer' name='phone_number' />
            </LeadFormInput>
            <ButtonContainer>
              <PrimaryOutlineButton onClick={() => {
                setLeadFormActive(false);
                onRequestClose();
              }} disabled={formIsLoading}>
                Annuleren
              </PrimaryOutlineButton>
              <PrimaryButton type="submit" onClick={handleSubmit} disabled={formIsLoading}>
                {formIsLoading ? <Loader css={{ margin: 0 }} invertedColor /> : 'Verzenden'}
              </PrimaryButton>
            </ButtonContainer>
          </LeadFormContainer>
      )}
    </ThemeProvider>
  );
};

LeadFormFinal.propTypes = {
  settings: PropTypes.shape({
    leadFormHeader: PropTypes.string.isRequired,
    leadFormText: PropTypes.string.isRequired,
  }).isRequired,
};

export default LeadFormFinal;
